export default function createPersistedState() {
  return store => {
    // 从本地存储加载状态
    const savedState = localStorage.getItem('vuex')
    if (savedState) {
      try {
        store.replaceState({
          ...store.state,
          user: JSON.parse(savedState).user
        })
      } catch (error) {
        console.error('Failed to parse saved state:', error)
      }
    }
    
    // 监听状态变化并保存到本地存储
    store.subscribe((mutation, state) => {
      // 只保存user模块的关键状态
      const userState = {
        user: {
          token: state.user.token,
          id: state.user.id,
          username: state.user.username,
          userInfo: state.user.userInfo,
          permissions: state.user.permissions
        }
      }
      
      localStorage.setItem('vuex', JSON.stringify(userState))
    })
  }
}